import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Typography } from '@mui/material'
import { t } from 'i18next'

import { unit, COLORS, ICONS } from '@hcr/ui'
import { isNotNull, isNotUndefined } from '@hcr/utils'

import { DateFormat } from '../../../../../models'
import { dateFormatter } from '../../../../../utils'
import type { BookingListPreviewProps } from '../../../../common/booking-list/types'

interface BookingListDescriptionProps extends Pick<BookingListPreviewProps, 'dateRange' | 'totalTickets'> {
  variant?: 'meta' | 'bodyM'
}

export const BookingListDescription = ({ dateRange, totalTickets, variant = 'meta' }: BookingListDescriptionProps) => {
  const letterSpacingSx = variant === 'bodyM' ? { letterSpacing: 'normal' } : undefined

  return (
    <Box display='inline'>
      <Box display='inline' marginRight={unit(3.5)}>
        {isNotUndefined(dateRange) ? (
          <Typography variant={variant} fontWeight='initial' color={COLORS.black} sx={letterSpacingSx}>
            {dateFormatter.formatDestinationDateRange({
              ...dateRange,
              fromFormat: DateFormat.Basic,
              toFormat: DateFormat.Basic,
            })}
          </Typography>
        ) : (
          <Typography variant={variant} fontWeight='initial' color={COLORS.black} sx={letterSpacingSx}>
            {t('booking.no-accommodation-booked')}
          </Typography>
        )}
      </Box>

      {isNotNull(totalTickets) && totalTickets > 0 && (
        <Typography
          variant={variant}
          fontWeight='initial'
          color={COLORS.black}
          sx={{ whiteSpace: 'nowrap', ...letterSpacingSx }}
        >
          <FontAwesomeIcon
            aria-hidden='true'
            color={COLORS.black}
            icon={ICONS.farLayerGroup}
            style={{ marginRight: unit(1) }}
          />
          {totalTickets > 1
            ? t('utils.tickets-count-plural', { count: totalTickets })
            : t('utils.tickets-count', { count: totalTickets })}
        </Typography>
      )}
    </Box>
  )
}
